{
  "de": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Logo ändern (png erforderlich)",
        "changeThemeColor": "Neue Themenfarbe auswählen"
      },
      "errors": {
        "themeColorInvalid": "Geben Sie sechs Zeichen ein, 0-9 oder A-F. Zum Beispiel 096553."
      },
      "labels": {
        "customerThemeColor": "Themenfarbe für Kunden",
        "customerThemeColorExlainer": "Diese Farbe wird für das Kundenportal verwendet. Übernehmen Sie die Identität eines Kunden, um dies in Aktion zu sehen.",
        "logo": "Logo"
      },
      "paused": {
        "description": "Ihr Konto bei {client} besteht weiterhin, aber Ihr Zugriff ist derzeit deaktiviert, daher bleibt die Plattform geschlossen. Ein Inhaber Ihrer Organisation kann Ihren Zugriff wieder aktivieren.",
        "noAccess": "Kein Zugriff",
        "open": "Öffnen",
        "title": "Ihr Zugriff ist pausiert",
        "yourOrganizations": "Ihre Organisationen"
      },
      "picture_logo_format": {
        "round": "Rundes Logo",
        "square": "Quadratisches Logo"
      }
    }
  }
}
